import Splide from '@splidejs/splide';

// SVGS e imagens (mantido)
function requireAll(r) {
  r.keys().forEach(r);
}
requireAll(require.context("../svg/", true, /\.svg$/));
requireAll(require.context("../images/", true, /\.(png|jpe?g)$/));

// Menu overlay
function initOverlayMenu() {
  const header = document.getElementById('masthead');
  if (!header) {
    console.warn('[overlay] header #masthead não encontrado');
    return;
  }
  const openButtons = header.querySelectorAll('.menu-toggle');
  const overlay = header.querySelector('.nav-overlay');
  if (!overlay) {
    console.warn('[overlay] .nav-overlay não encontrado');
    return;
  }

  console.log('[overlay] init', {
    readyState: document.readyState,
    buttons: openButtons ? openButtons.length : 0,
    overlayFound: !!overlay
  });

  const toggle = () => {
    const isOpen = overlay.classList.toggle('is-open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    console.log('[overlay] toggle', { isOpen });
  };

  openButtons.forEach(btn => btn.addEventListener('click', toggle));
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) toggle();
  });

  // Fallback por delegação (caso os botões sejam re-renderizados)
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest && t.closest('#masthead .menu-toggle')) {
      e.preventDefault();
      toggle();
    }
  });

  // Fechar com ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      toggle();
    }
  });

  // API de debug
  window.__tavrosMenuDebug = { header, overlay, openButtons, toggle };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOverlayMenu);
} else {
  initOverlayMenu();
}

